import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { gsap, Expo, Quad } from 'gsap';

@Component({
    selector: 'app-home-show-list',
    templateUrl: './home-show-list.component.html',
    styleUrls: ['./home-show-list.component.scss']
})
export class HomeShowListComponent implements OnInit {
    @Input() data: any = {}
    @Input() isMobile: boolean
    private touchStartTime: number = 0;

    constructor(
        private router: Router
    ) { }

    ngOnInit(): void {
    }

    navigateToTargetRoute(path: string) {
        this.router.navigate([path]);
        setTimeout(() => {
            this.router.navigate([path]);
        }, 100);

    }

    onTouchStart(event: TouchEvent, path: string): void {
        // Record the time when touch starts
        this.touchStartTime = Date.now();
      }
    
      onTouchEnd(event: TouchEvent, path: string): void {
        // Calculate the duration of the touch
        const touchDuration = Date.now() - this.touchStartTime;
    
        // Check if the touch is short enough to be considered a "tap"
        if (touchDuration < 300) {
          console.log('Tap detected!', event);
          this.handleTap(path);
        }
      }
    
      handleTap(path: string): void {
        // Perform the action on tap
        console.log('Element tapped!');
        this.router.navigate([path]);
      }


      onSwipeRight(e:any) {

      }

      onSwipeLeft(e:any) {

      }
}
